import { P3 } from "./P3";
import { ReactNode } from "react";
import { cn } from "../../ClassName";

interface Props {
  className?: string;
  children?: ReactNode;
  id?: string;
}

export function P3B(props: Props) {
  return (
    <P3 className={cn(`tw-font-bold`, props.className)} id={props.id}>
      {props.children}
    </P3>
  );
}
